import '../public';

import { Collapse } from 'bootstrap';

import { IWebsite } from '../../../../typings/website';
import { back2Top } from '../components/back2top';
import { processPageContent } from '../components/pageContent';
import { initPhotoSwipeSingleImage } from '../components/photoSwipeGallery';
import { addClass, hasClass } from '../helpers/generic';
import { modalBackdropResize } from '../helpers/modals';
import {
    enableToggleMenuOnHover,
    getNavbarCollapse,
    handleAnchorLinks,
    setToggleMenuPositionEvents,
    stickyNavigationToggle,
} from '../helpers/navigation';
import { scrollableResponsiveTables, scrollToHash } from '../helpers/scroll';

declare global {
    interface Window {
        __WEBSITE__: IWebsite;
    }
}

// Initial onLoad settings for the website page
const onPageLoaded = (): void => {
    const html = document.getElementsByTagName('html')[0];
    const navBar = getNavbarCollapse(); // reference to the main menu;
    window.__WEBSITE__.AppSettings.primaryNavigation = navBar;

    // Primary navigation settings:
    setToggleMenuPositionEvents(); // set events
    stickyNavigationToggle(); // first init of sticky navigation check
    enableToggleMenuOnHover(); // open menu also on :hover
    handleAnchorLinks(); // osetreni odkazu v hlavnim menu na kotvu v ramci stejne stranky

    // zavreni mobilniho menu pri kliknuti na polozky
    // "a:not([data-toggle])" - to avoid issues caused when you have dropdown inside navbar
    navBar.querySelectorAll('a:not([data-bs-toggle])').forEach((link) => {
        link.addEventListener('click', (e) => {
            const bsCollapse = new Collapse(navBar);
            bsCollapse.hide();
        });
    });

    const qrcPageLink = document.getElementsByClassName('footer-links__link--qrc-page')[0];
    if (qrcPageLink) {
        initPhotoSwipeSingleImage(qrcPageLink as HTMLLinkElement);
    }

    const linksToImages = document.querySelectorAll(
        // eslint-disable-next-line prettier/prettier
        '#page-content a[href$=\'.jpg\']:has(img), ' +
                '#page-content a[href$=\'.png\']:has(img), ' +
                '#page-content a[href$=\'.gif\']:has(img), ' +
                '#page-content a[href$=\'.JPG\']:has(img), ' +
                '#page-content a[href$=\'.PNG\']:has(img), ' +
                '#page-content a[href$=\'.GIF\']:has(img), ' +
                '#page-content a[href*=\'image.php?img=\']:has(img)'
    );
    for (let i = 0; i < linksToImages.length; i++) {
        const linkToImage: HTMLLinkElement = linksToImages[i] as HTMLLinkElement;
        // to prevent attaching double-events
        // (dela to pak problem pri zavirani, .pswp--open se neodstrani):
        if (
            !hasClass(linkToImage, 'related-files__item-link') &&
            !hasClass(linkToImage, 'photo-gallery__item-link') &&
            !hasClass(linkToImage, 'image-carousel__link')
        ) {
            initPhotoSwipeSingleImage(linkToImage);
        }
    }

    const linksToFooterImages = document.querySelectorAll(
        // eslint-disable-next-line prettier/prettier
        '#footer a[href$=\'.jpg\']:has(img), ' +
        '#footer a[href$=\'.png\']:has(img), ' +
        '#footer a[href$=\'.gif\']:has(img), ' +
        '#footer a[href$=\'.JPG\']:has(img), ' +
        '#footer a[href$=\'.PNG\']:has(img), ' +
        '#footer a[href$=\'.GIF\']:has(img), ' +
        '#footer a[href*=\'image.php?img=\']:has(img)',
    );
    for (let i = 0; i < linksToFooterImages.length; i++) {
        const linkToImage: HTMLLinkElement = linksToFooterImages[i] as HTMLLinkElement;
        // to prevent attaching double-events
        // (dela to pak problem pri zavirani, .pswp--open se neodstrani):
        if (
            !hasClass(linkToImage, 'related-files__item-link') &&
            !hasClass(linkToImage, 'photo-gallery__item-link') &&
            !hasClass(linkToImage, 'image-carousel__link')
        ) {
            initPhotoSwipeSingleImage(linkToImage);
        }
    }

    // "obliznuti" obsahu specifickymi funkcionalitami
    processPageContent(document.body);

    // back2top button
    back2Top(); // first init

    //manageMenuItems(); ...executed as callback in stickyNavigationToggle
    scrollableResponsiveTables();

    // scroll to url hash (if present)
    setTimeout(function () {
        scrollToHash();
    }, 500); // je potreba pockat, az se upravi menu

    addClass(html, 'page-loaded');
};

const onWindowScroll = (e: UIEvent): void => {
    stickyNavigationToggle(); // sticky navigation check
    back2Top(); // back2top button check
};

const onWindowResize = (e: UIEvent): void => {
    stickyNavigationToggle();
    //manageMenuItems(); ...executed as callback in stickyNavigationToggle
    modalBackdropResize();
    scrollableResponsiveTables();
};

window.addEventListener('resize', onWindowResize);

document.addEventListener('scroll', onWindowScroll, false);

document.addEventListener('DOMContentLoaded', onPageLoaded);

// add simple support for lazy-load of background images:
document.addEventListener('lazybeforeunveil', function (e: Event) {
    const bg = (e.target as HTMLElement).getAttribute('data-bg');
    if (bg) {
        (e.target as HTMLElement).style.backgroundImage = 'url(' + bg + ')';
    }
});
